import { useEffect, useState } from 'react'
import { useWarehouse } from '@/context/WarehouseContext'

const WarehouseSelectionModal = () => {
  const {
    warehouses,
    selectedWarehouseId,
    suggestedWarehouse,
    geolocationStatus,
    shouldPromptSelection,
    completeInitialSelection,
  } = useWarehouse()

  const [draftWarehouseId, setDraftWarehouseId] = useState(selectedWarehouseId)
  const [isDraftTouched, setIsDraftTouched] = useState(false)

  useEffect(() => {
    if (!shouldPromptSelection) {
      return
    }

    if (isDraftTouched) {
      return
    }

    if (suggestedWarehouse?.id) {
      setDraftWarehouseId(suggestedWarehouse.id)
      return
    }

    setDraftWarehouseId(selectedWarehouseId)
  }, [
    suggestedWarehouse?.id,
    selectedWarehouseId,
    shouldPromptSelection,
    isDraftTouched,
  ])

  if (!shouldPromptSelection) {
    return null
  }

  const helperText =
    geolocationStatus === 'requesting'
      ? 'Пробуем определить ближайший город по геолокации.'
      : geolocationStatus === 'granted' && suggestedWarehouse
        ? `По геолокации ближе всего: ${suggestedWarehouse.name}.`
        : geolocationStatus === 'denied'
          ? 'Вы запретили доступ к геолокации, поэтому выберите город вручную.'
          : geolocationStatus === 'unavailable'
            ? 'Доступ к геолокации разрешен, но определить местоположение не удалось. Выберите город вручную.'
          : geolocationStatus === 'unsupported'
            ? 'Ваш браузер не поддерживает геолокацию, выберите город вручную.'
            : 'Выберите город, чтобы показывать остатки нужного склада.'

  return (
    <div className="fixed inset-0 z-[1200] flex items-center justify-center bg-black/55 px-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="warehouse-modal-title"
        className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl"
      >
        <div className="space-y-2">
          <h2 id="warehouse-modal-title" className="text-xl font-semibold text-gray-900">
            Выберите город
          </h2>
          <p className="text-sm text-gray-600">{helperText}</p>
        </div>

        <div className="mt-5 space-y-3">
          {warehouses.map((warehouse) => {
            const isSuggested = suggestedWarehouse?.id === warehouse.id
            const isSelected = draftWarehouseId === warehouse.id

            return (
              <label
                key={warehouse.id}
                className={`flex cursor-pointer items-start gap-3 rounded-xl border p-4 transition-colors ${
                  isSelected
                    ? 'border-primary bg-primary-light/40'
                    : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                }`}
              >
                <input
                  type="radio"
                  name="warehouse-city"
                  value={warehouse.id}
                  checked={isSelected}
                  onChange={() => {
                    setDraftWarehouseId(warehouse.id)
                    setIsDraftTouched(true)
                  }}
                  className="mt-1 h-4 w-4 accent-primary"
                />
                <span className="min-w-0">
                  <span className="flex items-center gap-2 text-base font-medium text-gray-900">
                    <span>{warehouse.name}</span>
                    {isSuggested ? (
                      <span className="rounded-full bg-primary/10 px-2 py-0.5 text-xs text-primary">
                        Геометка
                      </span>
                    ) : null}
                  </span>
                </span>
              </label>
            )
          })}
        </div>

        <button
          type="button"
          onClick={() => completeInitialSelection(draftWarehouseId)}
          className="mt-6 h-11 w-full rounded-xl bg-primary text-sm font-semibold text-white transition-colors hover:bg-primary-hover"
        >
          Продолжить
        </button>
      </div>
    </div>
  )
}

export default WarehouseSelectionModal
